module.exports = __webpack_public_path__ + "static/media/arrow_drop_down.d77e4dd8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/arrow_drop_down.svg
// module id = 1839
// module chunks = 0